/**
 * Adapters between FoodPreferenceForm's onSave body and the transcript's
 * captured-item payload shape (matches what the Python agent emits and
 * what Go's SaveSection fan-out reads on Save & next).
 *
 *   FoodPreferenceForm onSave body   → captured "add" payload
 *   {kind, ingredient}
 *      →
 *   {kind, ingredient, name, value}
 *
 * `name` + `value` are convenience mirrors — the review table +
 * captured-item cards read them for display.
 */

/**
 * FoodPreferenceForm onSave body → captured "add" payload.
 */
export function bodyToCapturedAdd(body) {
  const kind = (body.kind || "likes").toString();
  const ingredient = (body.ingredient || "").trim();
  return {
    kind,
    ingredient,
    name:  ingredient,
    value: ingredient ? `${ingredient} · ${kind}` : "",
  };
}

/**
 * Stub — food preferences has no distinct update path (every save is a
 * whole-doc PUT). Same shape as add for symmetry.
 */
export function bodyToCapturedUpdate(body /* , context */) {
  return bodyToCapturedAdd(body);
}
